import { requestWithPromise } from '..'
import { HttpMethods, makeQueryStringFromObject } from '../apiHelper'
import { LanguageLocales } from '../constants'
import apiClient from './apiClient'

export const CONTEXTS = {
  shifts: 'shifts',
  documents: 'documents',
  validationDocument: 'validation-document'
}

export const acceptMaccsInternship = (user, internship) => apiClient.post(user, 'maccs-internship/accept', { maccsInternship: internship.id })

export const cancelMaccsInternship = (user, internship) => apiClient.patch(user, 'maccs-internship/cancel', { maccsInternship: internship.id })

export const createMaccsInternship = (user, body) => apiClient.post(user, 'api/maccs-internships', body)

export const deleteMaccsInternship = (user, internship) => apiClient.delete(user, `api/maccs-internships/${internship.id}`)
export const duplicateMaccsInternship = (user, internship) => apiClient.post(user, 'maccs-internship/duplicate', { maccsInternship: internship.id })

export const getAllMaccsInternships = (user, queryParameters = {}) => apiClient.get(user, 'api/maccs-internships', queryParameters)

export const refuseMaccsInternship = (internship, user) => {
  return requestWithPromise('/maccs-internship/refuse',
    HttpMethods.PATCH,
    { maccsInternship: internship.id },
    user
  )
}

export const resetToPending = (user, internship) => apiClient.patch(user, 'maccs-internship/reset-to-pending', { maccsInternship: internship.id })

export const updateMaccsInternship = (user, internship, body) => apiClient.patch(user, `api/maccs-internships/${internship.id}`, body)

export const getMaccsInternshipShifts = (maccsInternship, user, parameters = {}) => {
  return requestWithPromise(
    `/api/maccs-internships/${maccsInternship.id}/shifts${makeQueryStringFromObject(parameters)}`,
    HttpMethods.GET,
    null,
    user)
    .then(json => json?.data ?? [])
}

export const getMaccsInternshipDocuments = (maccsInternship, user, parameters = {}) => {
  const queryString = makeQueryStringFromObject(parameters)

  return requestWithPromise(
    `/api/maccs-internships/${maccsInternship.id}/documents${queryString}`,
    HttpMethods.GET,
    null,
    user)
    .then(json => {
      if (json && json.data) {
        return json.data
      }
    })
}

export const validateScheduleMaccsInternship = (body, user) => {
  return requestWithPromise(
    '/maccs-internship/validate-schedule',
    HttpMethods.PATCH,
    body,
    user)
    .then(json => {
      if (json && json.data) {
        return json.data
      }
    })
}

export const invalidateScheduleMaccsInternship = (body, user) => {
  return requestWithPromise(
    '/maccs-internship/invalidate-schedule',
    HttpMethods.PATCH,
    body,
    user)
    .then(json => {
      if (json && json.data) {
        return json.data
      }
    })
}

export const exportValidatedMaccsInternship = (body, user, parameters = {}) => {
  return requestWithPromise(
    `/maccs-internship/export-validated-maccs-internship${makeQueryStringFromObject(parameters)}`,
    HttpMethods.POST,
    body,
    user)
    .then(({ job, status }) => {
      if (status === 'success') {
        return job
      }
    })
}

export const getContactPersons = (maccsInternship, user) => {
  return requestWithPromise(
    `/api/maccs-internships/${maccsInternship.id}/contact-persons`,
    HttpMethods.GET,
    null,
    user
  ).then(json => {
    if (json && json.data) {
      return json.data
    }
  })
}

export const createMaccsInternshipShift = (maccsInternship, shift, user) => {
  return requestWithPromise(
    `/api/maccs-internships/${maccsInternship.id}/shifts`,
    HttpMethods.POST,
    shift.toRequestBody(),
    user
  )
}

export const updateMaccsInternshipShift = (maccsInternship, shift, user) => {
  return requestWithPromise(
    `/api/maccs-internships/${maccsInternship.id}/shifts/${shift.id}`,
    HttpMethods.PATCH,
    shift.toRequestBody(),
    user
  )
}

export const getValidationDocument = (maccsInternship, user) => {
  return requestWithPromise(
    `/api/maccs-internships/${maccsInternship.id}/assistant-validation-document`,
    HttpMethods.GET,
    null,
    user
  ).then(json => json?.data ?? [])
}

export const deleteValidationDocument = (maccsInternship, user) => {
  return requestWithPromise(
    `/api/maccs-internships/${maccsInternship.id}/assistant-validation-document`,
    HttpMethods.DELETE,
    null,
    user
  ).then(json => json?.data)
}

export const exportTimeline = (user, { start, end, filters = {}, language = LanguageLocales.EN }) => {
  return requestWithPromise(
    '/maccs-internship/export-timeline',
    HttpMethods.POST,
    { start, end, filters, language },
    user
  )
}
